<div class="loop-detail-modal">
    <div class="loop-modal-title">
        <div class="title mx-auto col-12" id="modal-basic-title">
            {{ "production-by-extraction-point" | lang }} {{ zoneName }} -
            {{ streetLabelModalTitle }} {{ streetName }}
        </div>
        <img
            appImageSelector
            alt="mt-image"
            imageType="icon"
            imageKey="close-gray"
            class="close-modal"
            alt="imagen-icon"
            (click)="activeModal.dismiss()"
        />
        <div class="col-12 text-center modal-subtitle">
            {{ modalSubtitle }} - {{ date | inputDateFormat }}
        </div>
    </div>

    <div class="mat-tabs">
        <mat-tab-group (selectedTabChange)="changeTab($event)">
            <mat-tab [label]="'chart' | lang">
                <ng-container *ngIf="modalData">
                    <app-prod-vs-plan-modal-chart
                        [zoneName]="zoneName"
                        [shiftLabel]="shiftLabel"
                        [streetName]="streetName"
                        [extractionPointDetailList]="
                            modalData?.productionByStreet
                        "
                    >
                    </app-prod-vs-plan-modal-chart>
                </ng-container>
            </mat-tab>

            <mat-tab [label]="'statistics' | lang">
                <ng-container *ngIf="modalData">
                    <app-prod-by-extraction-point-table
                        [data]="modalData?.productionByStreetStatistics"
                    >
                    </app-prod-by-extraction-point-table>
                </ng-container>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
